import aws from '../../utils/aws';
import config from '../../config/config';
import { Buffer } from 'buffer';

export const UPDATE_PASSWORD_LOAD = 'UPDATE_PASSWORD/UPDATE_PASSWORD_LOAD';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD/UPDATE_PASSWORD_FAILURE';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD/UPDATE_PASSWORD_SUCCESS';

export const UPDATE_PASSWORD_CLEAR_SESSIONS_LOAD = 'UPDATE_PASSWORD/UPDATE_PASSWORD_CLEAR_SESSIONS_LOAD';
export const UPDATE_PASSWORD_CLEAR_SESSIONS_SUCCESS = 'UPDATE_PASSWORD/UPDATE_PASSWORD_CLEAR_SESSIONS_SUCCESS';
export const UPDATE_PASSWORD_CLEAR_SESSIONS_FAILURE = 'UPDATE_PASSWORD/UPDATE_PASSWORD_CLEAR_SESSIONS_FAILURE';

export function updatePassword(email, password, verificationCode, dispatch, history) {
    dispatch({ type: UPDATE_PASSWORD_LOAD });

    const cognitoUser = aws.createUser(email);

    const base64Auth = Buffer.from(`${email}:${password}`, 'utf8').toString('base64');

    cognitoUser.confirmPassword(verificationCode, password, {
        onFailure: (error) => {
            dispatch({
                error,
                type: UPDATE_PASSWORD_FAILURE
            });
        },
        onSuccess: () => {
            dispatch(clearSessions(base64Auth));
            dispatch({ type: UPDATE_PASSWORD_SUCCESS });
            dispatch(updateExpiration(email));
            history.push('/');
        }
    });
}

export function setPassword(email, password, dispatch, history, cognitoUser) {
    dispatch({ type: UPDATE_PASSWORD_LOAD });

    cognitoUser.completeNewPasswordChallenge(password, {}, {
        onFailure: (error) => {
            dispatch({
                error,
                type: UPDATE_PASSWORD_FAILURE
            });
        },
        onSuccess: () => {
            dispatch({ type: UPDATE_PASSWORD_SUCCESS });
            dispatch(updateExpiration(email));
            history.push('/userSetup');
        }
    });
}

export function updateExpiration(email) {
    return {
        failureActionTypeOrCreator: (error) => {
            return { error, type: 'failed' };
        },
        forceSkipTokenMiddleware: true,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/updateExpiration`,
            body: { username: email }
        },
        successActionTypeOrCreator: () => {
            return { type: 'succeded' };
        }
    };
}

export function clearSessions(base64Auth) {
    return {
        forceSkipTokenMiddleware: true,
        failureActionTypeOrCreator: clearSessionsFailureActionCreator,
        fetchParams: {
            headers: {
                Authorization: `Basic ${base64Auth}`
            },
            method: 'POST',
            url: `${config.authApiUrl}/logout/user`
        },
        loadActionTypeOrCreator: UPDATE_PASSWORD_CLEAR_SESSIONS_LOAD,
        successActionTypeOrCreator: UPDATE_PASSWORD_CLEAR_SESSIONS_SUCCESS
    };
}

export function clearSessionsFailureActionCreator(error) {
    return {
        error,
        type: UPDATE_PASSWORD_CLEAR_SESSIONS_FAILURE
    };
}
